import React from 'react'
import JobDescription from '../../../../Components/JobDescription'

const SoftwareDev = () => {
  return (
   <JobDescription 
  jobTitle="Software Developer"
  location="Chennai"
  department="Developer"
  jobType="Full-Time"
  experienceLevel="1-3 Years"
  roleDescription="Join our dynamic development team at {brandName} where innovation meets execution. We're looking for a passionate Software Developer who thrives in building robust, scalable applications and loves solving complex technical challenges."
  responsibilities={[
    "Develop and maintain web applications using modern technologies",
    "Write clean, efficient, and well-documented code",
    "Collaborate with cross-functional teams to deliver features",
    "Participate in code reviews and technical discussions",
    "Debug and resolve technical issues across the stack",
    "Contribute to architecture decisions and best practices",
    "Stay updated with latest development trends and tools",
  ]}
  skills={[
    "JavaScript, React, Node.js",
    "HTML5, CSS3, TypeScript",
    "Database design (SQL/NoSQL)",
    "Git, API development, Testing frameworks",
    "Problem-solving and analytical thinking",
  ]}
  requirements={[
    "2-4 years of software development experience",
    "Strong foundation in programming fundamentals",
    "Experience with modern web frameworks",
    "Understanding of software development lifecycle",
    "Excellent communication and teamwork skills",
  ]}
  benefits={[
    "Work on cutting-edge projects with the latest technologies.",
    "Mentorship opportunities and continuous learning environment.",
    "Flexible work arrangements and growth-focused culture.",
  ]}
   onApply={() => console.log("Applied for Software Developer")}
  applyUrl="/apply/software-developer"
/>
  )
}

export default SoftwareDev